import React from 'react';
import { toast } from 'sonner';

const useToast = () => {
  const notify = (message: string, icon?: React.ReactNode) => {
    toast(message, {
      icon: icon,
      className: 'toast-message'
    });
  };

  return notify;
};

export { useToast };
